import $api from "../http";
import { IPaginationParams } from "../api/types";
import {
  IUserSubscription,
  IUserSubscriptionCancellationReason,
  IUserSubscriptionCancelModel,
  IUserSubscriptionCreditLog,
} from "../models/UserSubscription";

class UserSubscriptionServiceClass {
  async getByUserId(userId: string, pagination: IPaginationParams) {
    return await $api.get<{ items: IUserSubscription[]; total: number }>(
      `api/user-subscription/all-by-userId/${userId}?page=${pagination.currentPage}&pageSize=${pagination.pageSize}`
    );
  }

  async getCancellationReason(userSubscriptionId: string) {
    return await $api.get<IUserSubscriptionCancellationReason | null>(
      `api/user-subscription/cancellation-reason/by-subscription/${userSubscriptionId}`
    );
  }

  async getLogs(userSubscriptionId: string, pagination: IPaginationParams) {
    return await $api.get<{ items: IUserSubscriptionCreditLog[]; total: number }>(
      `api/user-subscription/log/all-by-subscription/${userSubscriptionId}?page=${pagination.currentPage}&pageSize=${pagination.pageSize}`
    );
  }

  async cancel(userSubscriptionId: string, model: IUserSubscriptionCancelModel) {
    return await $api.delete<{}>(`api/stripe/subscription/cancel/${userSubscriptionId}`, {
      data: model,
    });
  }

  async resumeCancellation(userSubscriptionId: string) {
    return await $api.put<{}>(
      `api/stripe/subscription/resume-cancellation/${userSubscriptionId}`,
      {}
    );
  }

  async setSuspend(userSubscriptionId: string, value: boolean) {
    return await $api.put<{}>(`api/user-subscription/set-suspend/${userSubscriptionId}`, { value });
  }

  async change(userId: string, subscriptionId: string) {
    return await $api.put<{}>(`api/stripe/subscription/change/${subscriptionId}`, { userId });
  }
}

export const UserSubscriptionService = new UserSubscriptionServiceClass();
